import Vue from "vue";
import Router from "vue-router";
import logs from "./views/members/loadder.vue";
import member from "./views/members/member.vue";
import getFriend from "./views/affiliate/getFriend.vue";
import otp from "./views/members/otp.vue";
import regisApi from "@/services/api/regis";
import liffHelper from "@/ultils/helper/liftHelper";
import store from '@/store'
const moment = require('moment')
function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = true //'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = true //'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = false //'Windows';
  } else if (/Android/.test(userAgent)) {
    os = false //'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = false //'Linux';
  }

  return os;
}
export const checkMobile = () => {
  let check = false
  const a = navigator.userAgent || navigator.vendor || window.opera
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      a
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4)
    )
  )
    check = true
  return check
}
const checkLine = () => /Line/.test(window.navigator.userAgent)
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/logs",
      name: "logs",
      component: logs,
      meta: {
        liffId: "1656090522-JwyomqwP"
      }
    },
    {
      path: "/member",
      name: "member",
      component: member,
      meta: {
        liffId: "1656090522-5ZmkyBlE"
      }
    },
    {
      path: "/otp",
      name: "otp",
      component: otp,
      meta: {
        liffId: "1656090522-5ZmkyBlE"
      }
    },
    {
      path: "/getFriend",
      name: "getFriend",
      component: getFriend,
      meta: {
        liffId: "1656090522-A50dBRDM"
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let checkOs = getOS()
  if (!checkLine()) {
    if (checkMobile()) {
      if (to.name === "logs") {
        if (to.query.uri !== undefined) {
          if (to.query.campaign !== undefined) {
            window.location = `line://app/1656090522-JwyomqwP?uri=${to.query.uri}&campaign=${to.query.campaign}`
          } else {
            window.location = `line://app/1656090522-JwyomqwP?uri=${to.query.uri}`
          }

        } else if (to.query.add !== undefined) {
          window.location = `line://app/1656090522-JwyomqwP?add=${to.query.add}`
        }

      }
      if (to.name === "getFriend") {
        window.location = `line://app/1656090522-A50dBRDM`
      }
    }
  }

  let liffId = to.matched[0].meta.liffId
  if (process.env.NODE_ENV === "development") {
    var params = {
      userId: "U0c1dfa0c6f547e4f64a930ea5a96f240",
      displayName: "DeedO;))",
      pictureUrl:
        "https://profile.line-scdn.net/0hxh4cEfPHJ0cJGgh7GeNYEDVfKSp-NCEPcStpISlIfyAsLjVBYX84c3lOeiMtejBDMHlvcn4TLid3",
      email: "wak_do@hotmail.com",
      statusMessage: ""
    };
  } else {
    let url = `https://aom-redirect.web.app${to.fullPath}`
    await liffHelper.login(liffId, url)
    var params = await liffHelper.getUserProfile(liffId);

  }
  store.commit('updateLine', params)
  let dataView = {
    lineId: params.userId,
    displayName: params.displayName,
    pictureUrl: params.pictureUrl,
    statusMessage: params.statusMessage,
    url: "",
    type: to.query.campaign ? "campaign" : "richMenu"
  };
  if (to.query.uri !== undefined) {
    if (to.query.campaign !== undefined) {
      dataView.url = `${to.query.uri}`;
      dataView["campaign"] = to.query.campaign
    } else {
      dataView.url = to.query.uri
    }
    console.log(dataView)
    await store.commit('updateData', dataView)
    // await regisApi.saveLog(dataView);
    // if (checkLine()) {

    //   if (!checkOs) {
    //     liffHelper.openWindow(to.query.uri, false)
    //     liffHelper.closeWindow()
    //   } else {
    //     window.location.href = to.query.uri;
    //   }

    // } else {
    //   window.location.href = to.query.uri;
    // }
    // window.location.href = to.query.uri
  } else if (to.query.add !== undefined) {
    dataView.url = to.query.add
    dataView["campaign"] = to.query.add
    dataView.type = "addLine"
    await store.commit('updateData', dataView)
    // await regisApi.saveLogCustom(dataView);
    // window.location = `line://oaMessage/@835nlrok/?`
  }

  if (to.name === "getFriend") {
    dataView.url = "friendGetFriend"
    dataView["campaign"] = "friendGetFriend"
    dataView["type"] = "friendGetFriend"
    await store.commit('updateData', dataView)
    // window.location = `line://app/1656090522-A50dBRDM`
  }

  next();
});
export default router;
